export function formatNum(n) {
  if (n === null || n === undefined) return "0";
  return n >= 1000 ? n.toLocaleString() : String(n);
}

export function formatPct(part, total) {
  if (!total) return "0%";
  return ((part / total) * 100).toFixed(1) + "%";
}

export function formatDate(isoDateString) {
  if (!isoDateString) return "—";
  const d = new Date(isoDateString);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleDateString();
}
